'use client';

const SUBMISSION_TOKEN_COOKIE = '__submission_token';
const COOKIE_MAX_AGE = 60 * 60; // 1 hour

function buildCookieString(name: string, value: string): string {
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  return `${name}=${value}; path=/; max-age=${COOKIE_MAX_AGE}; SameSite=Lax${secure}`;
}

/**
 * Sets the submission token cookie for authentication purposes.
 */
export function setSubmissionTokenCookie(token: string): void {
  document.cookie = buildCookieString(SUBMISSION_TOKEN_COOKIE, token);
}

/**
 * Clears the submission token cookie.
 */
export function clearSubmissionTokenCookie(): void {
  document.cookie = `${SUBMISSION_TOKEN_COOKIE}=; Max-Age=0; Path=/`;
}

/**
 * Gets the submission token cookie.
 */
export function getSubmissionTokenCookie(): string | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(
    new RegExp(`${SUBMISSION_TOKEN_COOKIE}=([^;]+)`)
  );
  return match ? match[1] : null;
}
